<template>
  <li
    :class="`item main--category--item text-center relative cursor-pointer text-ellipsis category-item capitalize transition-colors duration-200 bg-inherit hover:bg-primary hover:text-white ${isActive ? 'active-category' : ''}`.trim()">
    <!-- main category -->
    <NuxtLink :to="formattedCategoryLink" :title="item[nameKey]"
      class="flex items-center px-2 md:px-2.5 py-4 w-full h-full max-h-[56px] overflow-hidden text-[13px] lg:text-[14px] 3xl:text-[16px] text-ellipsis whitespace-nowrap">
      {{ item[nameKey] }}</NuxtLink>
    <!-- sub categor(ies) -->
    <ul v-if="item && item.children && item.children.length > 0"
      :class="`nested-list w-full min-w-[200px] md:overflow-y-auto categories__scrollbar overscroll-none ${(item.children.length == 1) ? 'md:min-w-[270px]' : (item.children.length == 2) ? 'lg:min-w-[460px]' : (item.children.length > 2) ? 'md:w-[524px] lg:w-[604px] xl:w-[754px] 2xl:w-[854px] 3xl:w-[924px]' : ''} ${positionStyling}`">
      <HomeSubCategoryItem v-for="nestedItem in item.children" :key="nestedItem.id" :nestedItem="nestedItem"
        :item="item" />
    </ul>
  </li>
</template>

<script>
import { trimText } from "@/helpers";
import HomeSubCategoryItem from "../homeCategories/SubCategoryItem.vue";
import defaultImg from "@/assets/icons/cezma_default_icon.png";

export default {
  props: {
    isActive: {
      type: Boolean,
      default: false,
      requried: true
    },
    length: {
      type: Number,
      requried: true
    },
    index: {
      type: Number,
      requried: true
    },
    item: {
      type: Object,
      default: () => { },
      requried: true
    }
  },
  computed: {
    positionStyling() {
      const halfLength = Math.round(this.length / 2);
      const isMoreThanFiveItems = this.length > 5 && window.innerWidth > 640;
      return this.index == halfLength ||
          this.index === halfLength + 1 ||
          this.index === halfLength - 1 ||
          this.index === halfLength - 2
          ? "left-[50%] translate-x-[-50%]" :
          this.index > halfLength && isMoreThanFiveItems
         ? "right-0 left-auto rtl:left-0 rtl:right-auto lg:rtl:left-0 lg:rtl:right-auto lg:left-auto lg:right-0"
        :"rtl:right-0 rtl:left-auto right-auto left-0";
    },
    formattedCategoryLink() {
      if (this.item?.link) {
        return this.item?.link;
      } else {
        let queryToUrl = `${(this.item?.id !== "more" &&
          `&main_category_id=${this.item?.id}`) ||
          ""}${`&sort_by=date&sort_type=desc`}${`&from=list`}`.replace(/^&/, "");
        let encodedQuery = btoa(encodeURIComponent(queryToUrl));
        return `${this.ROUTESNAMES.user.products}?${encodedQuery}`;
      }
    }
  },
  components: {
    HomeSubCategoryItem
  },
  methods: {
    trimText,
    lazyLoadSubItemsImages(){
      const lazyLoadElements = document.querySelectorAll('.lazy-load');
      const haveAllImagesAlreadyLoaded = Array.from(lazyLoadElements).every(element => element.classList.contains('loaded'));

      if(haveAllImagesAlreadyLoaded){
        return;
      }
      
      const loadImageContent = (element) => {
        const dataSrc = element.getAttribute('data-src') || defaultImg;
        const dataAlt = element.getAttribute('data-alt') || '';

        if (dataSrc) {
          const src = encodeURI(dataSrc) || dataSrc;
          const img = new Image();
          img.src = src;
          img.width = 24;
          img.height = 24;
          img.alt = dataAlt;
          img.onload = () => {
            element.style.backgroundImage = `url(${src})`;
            element.classList.add('loaded');
          }

          img.onerror = (e) => {
            e.target.src = defaultImg;
            e.onerror = null;
            element.style.backgroundImage = `url(${defaultImg})`;
            element.classList.add('loaded');
            return true;
          };
        }
      }
      
      lazyLoadElements.forEach(element => {
          const parentDropdown = element.closest('.main--category--item');
          parentDropdown.addEventListener('mouseenter', () => loadImageContent(element), { once: true });
      });
    }
  },
  mounted(){
    this.lazyLoadSubItemsImages();
  }
};
</script>

<style lang="scss" scoped>
.category-item {
  .nested-list {
    padding: 1rem;
    background: #ffffff;
    box-shadow: 0px 4px 4px #00000029;
    border-radius: 0px 0px 25px 25px;
    position: absolute;
    top: calc(100% - 9rem);
    display: grid;
    z-index: -999;
    opacity: 0.2;
    max-height: 0;
    pointer-events: none;
    grid-template-columns: repeat(auto-fill, minmax(calc(300px), 1fr));
    grid-row-gap: 0.3rem;
    grid-column-gap: 0.3rem;
    justify-content: center;
    transition: 0.2s linear;
    transition-property: opacity, top, max-height;

    @media (min-width: 1200px) {
      grid-template-columns: repeat(auto-fill, minmax(calc(230px), 1fr));
    }

    @media (max-width: 1200px) {
      grid-template-columns: repeat(auto-fill, minmax(calc(180px), 1fr));
    }

    @media (max-width: 1024px) {
      grid-template-columns: repeat(2, fr);
    }

    @media (max-width: 420px) {
      grid-template-columns: 1fr;
    }

    li {
      text-align: initial;
      background: #0963ff0d;
      border-radius: 8px;
      color: #000000;
      padding: 0.5rem 0.8rem;
      width: 100%;
      cursor: pointer;
      transition: background 0.2s linear;

      &:hover {
        background: #0963ff29;
      }

      &:active {
        background: var(--primary-clr);
      }
    }
  }

  &:hover ul.nested-list, &:focus-within ul.nested-list{
    opacity: 1;
    top: 100%;
    z-index: -1;
    pointer-events: auto;
    max-height: calc(100vh - 200px);
  }

  .categories__scrollbar {
    scrollbar-gutter: stable;

    &::-webkit-scrollbar {
      width: 5px;
    }


    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background: var(--scrollbar-default-clr);
      transition: background 0.2s linear;

      &:hover {
        background: var(--scrollbar-on-hover-clr);
      }
    }
  }
}</style>